import axios from "axios";

const api = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`,
  withCredentials: true,
});

// Fallback for custom domains where cross-site cookies are blocked: attach the
// stored access token as a Bearer header. Cookies still work for same-origin.
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("zk_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export function fmtErr(err, fallback = "Something went wrong. Please try again.") {
  const detail = err?.response?.data?.detail;
  if (detail == null) return err?.message || fallback;
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export const AU_PHONE = /^(\+?61|0)[2-9]\d{8}$/;
export const cleanPhone = (p) => (p || "").replace(/[\s\-()]/g, "");
export const isAuPhone = (p) => AU_PHONE.test(cleanPhone(p));

export default api;
